<div class="outer-container">
  <h2>{{errorTitle}}</h2>
  <p>{{errorMessage}}<a *ngIf="displayRouterLink" [routerLink]="returnUrl">{{ returnUrl }}</a></p>
  <button *ngIf="displayReturnButton" (click)="onReturn()" mat-raised-button color="primary" type="button">
    {{'common.buttons.returnToPreviousPage' | transloco}}
  </button>
</div>
